import { Component, OnInit } from '@angular/core';
import { LocalLocationContainer } from '../shared/local-location-container.model';

@Component({
  selector: 'app-plant-manager-locations',
  templateUrl: './plant-manager-locations.component.html',
  styleUrls: ['./plant-manager-locations.component.scss']
})
export class PlantManagerLocationsComponent implements OnInit {

  selectedLocation: LocalLocationContainer;

  constructor() {
  }

  ngOnInit() {
  }
}
